import { Injectable } from '@angular/core';
import {Observable} from 'rxjs';
import {SubsidiaryCollection} from './subsidiary-collection';
import * as classTransformer from 'class-transformer';
import {HttpClient} from '@angular/common/http';
import {map} from 'rxjs/operators';
import {Subsidiary} from './subsidiary';

@Injectable({
    providedIn: 'root',
})
export class SubsidiaryService {
    constructor(
        private httpClient: HttpClient,
    ) {
    }

    static buildIri(subsidiary: Subsidiary | string): string {
        if (typeof subsidiary === 'string') {
            return `/cpe/subsidiaries/${subsidiary}`;
        }

        return `/cpe/subsidiaries/${subsidiary.id}`;
    }

    public getAll(): Observable<any> {
        return this.httpClient
            .get('/subsidiaries')
            .pipe(map((result: any) => {
                const collection = new SubsidiaryCollection();
                collection.setTotalItems(result['totalItems']);
                collection.setSubsidiaries(
                    result['member'].map((subsidiaryData: any) => classTransformer.plainToInstance(Subsidiary, subsidiaryData))
                );

                return collection;
            }));
    }
}
